(() => {
  const isCasQuery = (value) => {
    const normalized = String(value || '')
      .trim()
      .replace(/[‐‑‒–—−]/g, '-')
      .replace(/\s+/g, '');
    return /^\d{2,7}-\d{2}-\d$/.test(normalized);
  };

  if (!window.__perfumeryStrictCasSearch && window.PerfumerySearchSynonyms) {
    const base = window.PerfumerySearchSynonyms;
    window.PerfumerySearchSynonyms = Object.freeze({
      normalize: base.normalize,
      resolve(value) {
        const original = String(value || '').trim();
        if (isCasQuery(original)) return original;
        return base.resolve(original);
      },
      getVariants(value) {
        const original = String(value || '').trim();
        if (!original) return [];
        if (isCasQuery(original)) return [original];
        return base.getVariants(original);
      },
      isCasQuery
    });
    window.__perfumeryStrictCasSearch = true;
  }

  customElements.whenDefined('predictive-search').then(() => {
    const PredictiveSearchElement = customElements.get('predictive-search');
    if (!PredictiveSearchElement || PredictiveSearchElement.prototype.__perfumeryDedupePatched) return;

    PredictiveSearchElement.prototype.mergeSynonymProductResults = function (texts) {
      const parsedSections = texts
        .map((text) => new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search'))
        .filter(Boolean);

      if (!parsedSections.length) return '';

      const donor = parsedSections.find((section) => section.querySelector('#predictive-search-results-products-list')) || parsedSections[0];
      const productList = donor.querySelector('#predictive-search-results-products-list');
      if (!productList) return donor.innerHTML;

      const getProductKey = (item) => {
        const href = item.querySelector('a[href*="/products/"]')?.getAttribute('href');
        if (!href) return null;

        try {
          const url = new URL(href, window.location.origin);
          const match = url.pathname.match(/\/products\/([^/]+)/i);
          if (match?.[1]) return decodeURIComponent(match[1]).toLowerCase();
          return url.pathname.replace(/\/+$/, '').toLowerCase();
        } catch (error) {
          return href.split('?')[0].split('#')[0].replace(/\/+$/, '').toLowerCase();
        }
      };

      const uniqueProducts = new Map();
      parsedSections.forEach((section) => {
        section.querySelectorAll('#predictive-search-results-products-list > li').forEach((item) => {
          const key = getProductKey(item);
          if (key && !uniqueProducts.has(key)) uniqueProducts.set(key, item);
        });
      });

      productList.innerHTML = '';
      [...uniqueProducts.values()].slice(0, 20).forEach((item, index) => {
        const clone = item.cloneNode(true);
        clone.id = `predictive-search-option-product-${index + 1}`;
        productList.appendChild(clone);
      });

      const liveCount = donor.querySelector('[data-predictive-search-live-region-count-value]');
      if (liveCount) liveCount.textContent = String(Math.min(uniqueProducts.size, 20));

      return donor.innerHTML;
    };

    PredictiveSearchElement.prototype.__perfumeryDedupePatched = true;
  });
})();
